<template>
    <v-container fluid class="pt-0">
        <HeaderListaPlanejamentoEcomm
            titulo="Lançamentos"
            :pesquisa.sync="pesquisa"
            @exportar="exportar"
            @importar="abrirImportacao"
            hideCadastrar
        />

        <v-card class="px-5 py-5 br-15 w-100 mt-5" elevation="0">
            <v-data-table
                class="elevation-0 tabela"
                :headers="headers"
                :items="dados"
                :items-per-page="10"
                :footer-props="tableConfig"
                :header-props="{ sortIcon: 'mdi-chevron-down' }"
                :search="pesquisa"
                item-key="id_pacote"
            >
                <!-- insere formatter para data_inicio, data_fim, data_limite_fornecedor, data_limite_ipdv -->
                <template v-slot:[`item.data_inicio`]="{ item }">
                    {{
                        item.data_inicio
                            ? $moment(item.data_inicio).format('DD/MM/YYYY')
                            : ''
                    }}
                </template>
                <template v-slot:[`item.data_fim`]="{ item }">
                    {{
                        item.data_fim
                            ? $moment(item.data_fim).format('DD/MM/YYYY')
                            : ''
                    }}
                </template>
                <template v-slot:[`item.data_limite_fornecedor`]="{ item }">
                    {{
                        item.data_limite_fornecedor
                            ? $moment(item.data_limite_fornecedor).format(
                                  'DD/MM/YYYY'
                              )
                            : ''
                    }}
                </template>
                <template v-slot:[`item.data_limite_ipdv`]="{ item }">
                    {{
                        item.data_limite_ipdv
                            ? $moment(item.data_limite_ipdv).format(
                                  'DD/MM/YYYY'
                              )
                            : ''
                    }}
                </template>
                <template v-slot:[`item.mes`]="{ item }">
                    {{ item.mes ? $moment(item.mes).format('MM/YYYY') : '' }}
                </template>
            </v-data-table>
        </v-card>

        <!-- Componente de importação -->
        <Importacao v-model="dialogoImportacao" @filtrar="filtrar" />

        <v-overlay :value="carregando" :z-index="300">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
</template>

<script>
import HeaderListaPlanejamentoEcomm from '@/views/planejamento_ecommerce/cadastro_plano_pacote/_components/headerListaPlanejamentoEcomm.vue'
import Importacao from './Importacao.vue'

export default {
    name: 'plano_pacote',
    components: {
        HeaderListaPlanejamentoEcomm,
        Importacao,
    },

    data() {
        return {
            carregando: false,
            pesquisa: '',
            dialogoImportacao: false,
            dados: [],
            tableConfig: {
                itemsPerPageOptions: [5, 10, 20, 50, 100, -1],
                itemsPerPageText: 'Linhas por páginas',
                ofText: 'de',
                pageText: '{0}-{1} de {2}',
            },
            headers: [
                {
                    text: 'Mês',
                    value: 'mes',
                    class: 'th-separador min-width-100',
                    align: 'center',
                    formater: (item) =>
                        this.$moment(item.mes).format('MMMM YYYY'),
                },
                {
                    text: 'Semana',
                    value: 'semana',
                    class: 'th-separador min-width-100',
                    align: 'center',
                },

                {
                    text: 'Data Inicial',
                    value: 'data_inicio',
                    class: 'th-separador min-width-100',
                    align: 'center',
                },
                {
                    text: 'Data Final',
                    value: 'data_fim',
                    class: 'th-separador min-width-100',
                    align: 'center',
                },
                {
                    text: 'Data limite fornecedor',
                    value: 'data_limite_fornecedor',
                    class: 'th-separador min-width-100',
                    align: 'center',
                },
                {
                    text: 'Data limite IPDV',
                    value: 'data_limite_ipdv',
                    class: 'th-separador min-width-100',
                    align: 'center',
                },
            ],
        }
    },

    created() {
        this.filtrar()
    },
    methods: {
        async exportar() {
            try {
                const response = await this.$http().post(
                    '/planejamentoEcommerce/data-limite/exportar',
                    {}
                )

                if (response.status == 200) {
                    this.$dialog.notify.success(
                        'Lancamento exportado com sucesso!'
                    )
                    window.location = this.$http('baseURL') + response.data.url
                } else {
                    this.$dialog.notify.error(
                        response.data.mensagem || 'Erro ao exportar Lancamento!'
                    )
                }
            } catch (error) {
                this.$dialog.notify.error(
                    'Erro de conexão ao exportar Lancamento!'
                )
                console.error('Erro na exportação:', error)
            }
        },

        abrirImportacao() {
            this.dialogoImportacao = true
        },
        async filtrar() {
            try {
                this.carregando = true
                const response = await this.$http().post(
                    '/planejamentoEcommerce/data-limite/lista',
                    {}
                )

                this.dados = response.data?.data || []
            } catch (error) {
                console.error('Erro ao carregar dados:', error)
                this.$dialog.notify.error(
                    'Erro ao carregar lista de Lancamento!'
                )
                this.dados = []
            } finally {
                this.carregando = false
            }
        },
    },
}
</script>
